<template>
  <div class="detail-body">
    <div class="hender">
      <div class="info">
        <span class="name">{{ detailInfo.patientName }}</span>
        <span class="gender">{{ detailInfo.patientSex }}</span>
        <span class="age">{{ detailInfo.patientAge }} 岁</span>
        <span class="phone">{{ detailInfo.phoneNo }}</span>
      </div>
      <Icon class="close-btn" type="md-close" @click="onClose" />
    </div>
    <div class="content">
      <uPrescription :detailInfo="detailInfo" />
      <uAnalysis
        ref="uAnalysisRef"
        :detailInfo="detailInfo"
        :auditStage="info.auditorType"
        @submitSuccess="submitSuccess"
        :isReplied="isReplied"
      />
    </div>
    <div class="footer-btng" v-if="!isReplied">
      <Button type="primary" @click="submit">确认回复</Button>
    </div>
  </div>
</template>


<script>
import uPrescription from "./uPrescription.vue";
import uAnalysis from "./uAnalysis.vue";
export default {
  components: {
    uPrescription,
    uAnalysis,
  },
  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
    isReplied: {
      //是否已回复
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      detailInfo: {},
    };
  },
  watch: {
    info(newValue, oldValue) {
      this.getData();
    },
  },
  methods: {
    onClose() {
      this.$emit("close");
    },
    submitSuccess() {
      this.$emit("submitSuccess");
    },
    submit() {
      this.$refs.uAnalysisRef.handleSubmit();
    },
    formatDrug(str) {
      if (str) {
        // 将字符串按,和%分割转换成数组对象
        const arr = str.split(",").filter((i) => i);
        // 遍历数组对象，将每个对象的label和value提取出来
        const result = arr.map((item) => {
          const [value, label, quantity] = item.split(/%|X/);
          return {
            label,
            value,
            quantity,
          };
        });
        return result;
      }
      return "";
    },

    // 比较两个数组的不同元素
    // 输入两个数组，返回包含相同元素、新增元素和删除元素的对象
    differ(list1, list2) {
      let same = list1.filter((item) => list2.includes(item));
      let add = list2.filter((item) => !list1.includes(item));
      let remove = list1.filter((item) => !list2.includes(item));
      return {
        same,
        add,
        remove,
      };
    },
    getData() {
      let obj = {
        dchlId: this.info.dchlId,
        meId: this.info.meId,
      };
      this.api2("medicationExaminationDetail", obj).then((res) => {
        let obj = res.result;
        this.formatData(obj);

        obj.drugs = obj.drugs.filter((i) => i.medicationType != 1); // 过虑掉正确的药品
        obj.drugs.forEach((i) => {
          i.auditResult = ""; //	结果 0 未回复 1 同意 2 拒绝;
          i.auditReason = "";
        });
        this.detailInfo = obj;
      });
    },
    formatData(obj) {
      obj.sanfangDrugList = this.formatDrug(obj.sanfangDrug); //系统开方
      obj.hisDrugList = this.formatDrug(obj.hisDrug); //医生处方
      obj.hisDrugLabelList = obj.hisDrugList.map((i) => i.label);

      const drugGroup = this.formatDrugGroup(obj.sanfangDrug);
      if (drugGroup) {
        this.hasGroup(obj, drugGroup);
      } else {
        this.notGroup(obj);
      }

      obj.hisDrugStr = obj.hisDrugList
        .map((i) => i.label + "X" + i.quantity)
        .join("　");
    },

    // 有分组的处方方式
    hasGroup(obj, drugGroup) {
      let addList = [],
        removeList = [],
        keys = Object.keys(drugGroup),
        arr = [];
      for (const key in drugGroup) {
        if (Object.prototype.hasOwnProperty.call(drugGroup, key)) {
          const list = drugGroup[key];
          let { same, add, remove } = this.differ(
            list.map((i) => i.label),
            obj.hisDrugLabelList
          );
          addList.push(add);
          removeList.push(remove);
          arr.push(
            key + "：" + list.map((i) => i.label + "X" + i.quantity).join("　")
          );
        }
      }
      obj.sanfangDrugStr = arr.join("<br/>");

      let addListStr = [];
      let removeListStr = [];
      keys.forEach((i, index) => {
        addListStr.push(`${i}：${addList[index].join("，") || "无"}`);
        removeListStr.push(`${i}：${removeList[index].join("，") || "无"}`);
      });
      obj.addDrugStr = addListStr.join("<br/>");
      obj.removeDrugStr = removeListStr.join("<br/>");
      let a1 = addList.reduce((pre, cur) => {
        return pre.concat(cur);
      }, []);
      let r1 = removeList.reduce((pre, cur) => {
        return pre.concat(cur);
      }, []);

      obj.addDrugList = obj.hisDrugList.filter((i) => a1.includes(i.label));
      obj.removeDrugList = obj.sanfangDrugList.filter((i) =>
        r1.includes(i.label)
      );
    },

    // 没有分组的处方方式
    notGroup(obj) {
      let { same, add, remove } = this.differ(
        obj.sanfangDrugList.map((i) => i.label),
        obj.hisDrugLabelList
      );
      obj.addDrugStr = add.join(",");
      obj.addDrugList = obj.hisDrugList.filter((i) => add.includes(i.label));
      obj.removeDrugStr = remove.join(",");
      obj.removeDrugList = obj.sanfangDrugList.filter((i) =>
        remove.includes(i.label)
      );
      obj.sanfangDrugStr = obj.sanfangDrugList
        .map((i) => i.label + "X" + i.quantity)
        .join("　");
    },

    formatDrugGroup(str) {
      if (!/【组\d+】/.test(str)) return null;
      // 将上面的内容分组
      const list = str.split(/,/).filter((i) => i);
      let groupArr = {};
      // 遍历数组对象，将每个对象的label和value提取出来
      list.forEach((item) => {
        let [group, value, label, quantity] = item.split(/】|%|X/);
        group = group + "】";
        let obj = {
          value,
          label,
          quantity,
        };
        groupArr[group] = groupArr[group] || [];
        groupArr[group].push(obj);
      });
      return groupArr;
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style scoped lang="scss">
.detail-body {
  background: #fff;
  padding: 15px;
  margin-left: 15px;
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  .hender {
    padding-bottom: 8px;
    font-weight: bold;
    border-bottom: 1px solid #cccc;
    position: relative;
    .close-btn {
      position: absolute;
      right: 0px;
      top: 0px;
      font-size: 20px;
      cursor: pointer;
    }
    .info {
      span {
        padding-right: 15px;
        &.name {
          font-size: 18px;
        }
      }
    }
  }
  .footer-btng {
    border-top: 1px solid #cccc;
    padding-top: 10px;
    text-align: center;
  }
  .content {
    height: 100%;
    line-height: 2em;
    overflow-y: auto;
    padding: 10px 0;
    :deep {
      & > div + div {
        padding-top: 10px;
        margin-top: 10px;
        border-top: 1px solid var(--el-border-color-light);
      }
      .info {
        border-bottom: 1px solid var(--el-border-color-light);
        padding-bottom: 10px;
        margin-bottom: 10px;
        span {
          padding-right: 15px;
          &.name {
            font-size: 16px;
            font-weight: bold;
            color: var(--subMenuActiveText);
          }
        }
      }
      .info-title {
        font-weight: bold;
        padding: 10px 0 5px 0;
        color: var(--subMenuActiveText);
        display: flex;
        justify-content: space-between;
      }
      .row {
        display: flex;
        .item {
          flex: 1;
          display: flex;
          .label {
            opacity: 0.7;
            padding-right: 15px;
            &.label2 {
              width: 120px;
              flex-shrink: 0;
              display: inline-block;
            }
          }
        }
      }
    }
  }
}
</style>